import { AppMessages } from '../types';
import { pl } from './pl';

export const ua: AppMessages = {
  ...pl,
  nav: { home: 'Головна', study: 'Навчання', questionDemo: 'Перегляд питання', exam: 'Іспит' },
  userMenu: {
    settings: 'Налаштування',
    status: 'Статус',
    logout: 'Вийти',
    anonymous: 'Не ввійшли',
    tierFree: 'Free',
    tierPremium: 'Premium',
    tierAdmin: 'Admin',
  },
  common: { loadingSession: 'Перевірка сесії...', yes: 'Так', no: 'Ні', days: 'днів' },
  landing: {
    eyebrow: 'Усі категорії іспиту від 0,16 PLN на день',
    title: 'Готуйтеся до водійських прав у темпі, який справді допомагає скласти іспит.',
    description: 'Тренуйте офіційні запитання з відео та зображеннями, навчайтеся короткими серіями і перевіряйте готовність у пробному іспиті. Категорії A, B, C, D, T та інші доступні в одному місці.',
    primaryCta: 'Почати навчання',
    secondaryCta: 'Спробувати пробний іспит',
    metricQuestions: 'запитань з каталогу',
    metricPriceValue: '0,16 PLN',
    metricPrice: 'на день',
    metricCategoriesValue: 'повне',
    metricCategories: 'охоплення категорій',
    heroAlt: 'Курсант проходить онлайн-тест на водійські права',
    featureOneTitle: 'Ви вчите те, що дає результат',
    featureOneText: 'Короткі серії карток допомагають швидко знайти прогалини і повернутися до запитань, які ще варто потренувати.',
    featureTwoTitle: 'Репетиція перед справжнім іспитом',
    featureTwoText: 'Ви проходите тести у форматі іспиту, з балами, історією результатів і медіа як у базі запитань.',
    featureThreeTitle: 'Один акаунт для всіх категорій',
    featureThreeText: 'Виберіть категорію іспиту і тренуйте повний матеріал для мотоцикла, легкового авто, вантажівки або автобуса.',
    proofTitle: 'Почніть з безкоштовного акаунта, а повний доступ коштує копійки',
    proofText: 'Спробуйте навчання без ризику, а коли захочете тренуватися без обмежень, виберіть доступ від 0,16 PLN на день. У пакеті всі категорії іспиту та повна база запитань.',
    profileCta: 'Перейти до профілю',
    createAccountCta: 'Створити акаунт',
  },
  home: {
    ...pl.home,
    title: 'Тести на водійські права',
    signedIn: 'Ви увійшли',
    username: 'Імʼя користувача',
    email: 'Email',
    noEmail: 'Email не вказано',
    providers: 'Провайдери входу',
    emailVerified: 'Email підтверджено',
    accountTier: 'Статус акаунта',
    premiumUntil: 'Premium до',
    login: 'Увійти',
    register: 'Зареєструватися',
    logout: 'Вийти',
    emailOrUsername: 'Email або імʼя користувача',
    password: 'Пароль',
    createAccount: 'Створити акаунт',
    pleaseWait: 'Зачекайте...',
    authenticationFailed: 'Не вдалося увійти.',
    or: 'або',
    googleNotConfigured: 'Вхід через Google ще не налаштований.',
    googleFailed: 'Не вдалося увійти через Google.',
    googleLoadFailed: 'Не вдалося завантажити вхід через Google.',
    usernamePlaceholder: 'Імʼя користувача',
    emailPlaceholder: 'Email',
    resendVerificationTitle: 'Надіслати лист підтвердження ще раз',
    accountEmail: 'Email акаунта',
    resendEmail: 'Надіслати ще раз',
    sending: 'Надсилання...',
    resetPasswordTitle: 'Скидання пароля через email',
    sendResetEmail: 'Надіслати лист скидання',
    changePasswordTitle: 'Змінити пароль',
    preferencesTitle: 'Налаштування навчання та іспиту',
    savePreferences: 'Зберегти налаштування',
    preferencesSaved: 'Налаштування збережено.',
    preferencesFailed: 'Не вдалося зберегти налаштування.',
    currentPassword: 'Поточний пароль',
    newPassword: 'Новий пароль',
    saving: 'Збереження...',
    changePassword: 'Змінити пароль',
    changePasswordFailed: 'Не вдалося змінити пароль.',
    deleteAccountTitle: 'Видалити акаунт',
    deleteAccountHint: 'Щоб підтвердити видалення, введіть імʼя користувача. Локальні акаунти також потребують поточного пароля.',
    usernameConfirmation: 'Підтвердження імені користувача',
    deleteAccount: 'Видалити акаунт',
    deleting: 'Видалення...',
    deleteAccountFailed: 'Не вдалося видалити акаунт.',
    activatePremiumCode: 'Активувати Premium-код',
    premiumCodePlaceholder: 'Введіть Premium-код',
    redeemCode: 'Активувати код',
    redeeming: 'Активація...',
    premiumActiveUntil: 'Premium активний до',
    redeemFailed: 'Не вдалося активувати Premium-код.',
    generatePremiumCodes: 'Згенерувати Premium-коди',
    generateCodes: 'Згенерувати коди',
    generating: 'Генерація...',
    generateFailed: 'Не вдалося згенерувати Premium-коди.',
    alreadySignedInTitle: 'Ви вже ввійшли',
    alreadySignedInText: 'Можете перейти до навчання або профілю.',
    studyModeCta: 'Режим навчання',
    profileCta: 'Профіль',
    backToHome: 'Головна',
    signInTitle: 'Увійти',
    createAccountTitle: 'Створити акаунт',
    authIntro: 'Один акаунт зберігає категорію іспиту, мову, прогрес навчання та історію тестів.',
    loginTab: 'Вхід',
    registerTab: 'Реєстрація',
    resendVerificationLink: 'Надіслати посилання підтвердження ще раз',
    forgotPassword: 'Забули пароль?',
    profileLoginTitle: 'Профіль користувача',
    profileLoginText: 'Увійдіть, щоб керувати категорією іспиту, мовою, акаунтом і статусом Premium.',
    premiumActive: 'Premium активний до',
    emailVerifiedShort: 'Email підтверджено',
    emailUnverifiedShort: 'Email не підтверджено',
    loginMethod: 'Вхід',
  },
  verifyEmail: {
    title: 'Підтвердження email',
    verifying: 'Підтвердження email...',
    incomplete: 'Посилання підтвердження неповне.',
    failed: 'Не вдалося підтвердити email.',
    backToSignIn: 'Повернутися до входу',
  },
  resetPassword: {
    title: 'Скидання пароля',
    incomplete: 'Посилання скидання неповне.',
    failed: 'Не вдалося скинути пароль.',
    setNewPassword: 'Встановити новий пароль',
    backToSignIn: 'Повернутися до входу',
  },
  notFound: {
    title: 'Сторінку не знайдено',
    text: 'Введена адреса не відповідає жодному екрану застосунку. Поверніться на головну сторінку або відкрийте один з доступних розділів.',
  },
  questionDemo: {
    pageTitle: 'Перегляд запитання',
    pageDescription: 'Витягніть випадкове екзаменаційне запитання та перевірте відповідь. Оберіть розділ для тренування базових або спеціалізованих запитань.',
    loginRequired: 'Увійдіть на головній сторінці, щоб завантажити запитання з бекенду.',
    loading: 'Перевірка сесії...',
    loadingCategories: 'Завантаження категорій...',
    loadQuestion: 'Завантажити інше запитання',
    loadingQuestion: 'Завантаження запитання...',
    languageLabel: 'Мова',
    scopeLabel: 'Розділ',
    categoryLabel: 'Категорія',
    scopeBasic: 'Базовий',
    scopeSpecialist: 'Спеціалізований',
    fetchErrorFallback: 'Не вдалося завантажити запитання.',
    categoriesErrorFallback: 'Не вдалося завантажити категорії.',
    publicPreviewNotice: 'Без акаунта можна переглянути 10 прикладових запитань, збережених локально в застосунку. Ми не завантажуємо їх з бекенду.',
    publicPreviewLoading: 'Завантаження безкоштовного набору з 10 запитань...',
    publicPreviewSignupButton: 'Створити безкоштовний акаунт',
    signupModalTitle: 'Безкоштовний перегляд завершено',
    signupModalText: 'Увійдіть або створіть безкоштовний акаунт, щоб продовжити навчання та відкрити більше запитань.',
    signupModalCreateAccount: 'Створити безкоштовний акаунт',
    signupModalLogin: 'У мене вже є акаунт',
    signupModalClose: 'Повернутися до перегляду',
  },
  study: {
    title: 'Режим навчання',
    description: 'Виберіть категорію іспиту та тег. Запитання показуються як картки відповідно до вашого прогресу.',
    loginRequired: 'Увійдіть на головній сторінці, щоб почати навчання.',
    loading: 'Перевірка сесії...',
    loadingCategories: 'Завантаження категорій і тегів...',
    languageLabel: 'Мова',
    categoryLabel: 'Категорія іспиту',
    tagLabel: 'Тег запитань',
    chooseScopeTitle: 'Виберіть обсяг навчання',
    allTags: 'Усі теги',
    start: 'Почати навчання',
    restart: 'Почати знову',
    loadingQuestions: 'Завантаження запитань...',
    nextQuestion: 'Далі',
    correct: 'Правильна відповідь',
    incorrect: 'Неправильна відповідь',
    correctAnswer: 'Правильна відповідь',
    progressCorrect: 'правильно',
    progressNotCorrect: 'ще ні',
    answered: 'Відповіді',
    correctCount: 'Правильні',
    remaining: 'У черзі',
    noQuestionLoaded: 'Виберіть категорію і почніть навчання.',
    fetchErrorFallback: 'Не вдалося завантажити запитання для навчання.',
    categoriesErrorFallback: 'Не вдалося завантажити категорії або теги.',
    submitErrorFallback: 'Не вдалося зберегти прогрес.',
    mediaUnavailable: 'Для цього запитання немає медіа.',
    adTitle: 'Коротка рекламна пауза',
    adText: 'Користувачі Free бачать рекламу після кожних 12 запитань у режимі навчання.',
    adContinue: 'Продовжити навчання',
    adCountdown: 'Продовження через',
  },
  exam: {
    title: 'Пробний іспит',
    description: 'Після старту завантажується повний набір екзаменаційних запитань для вибраної категорії. Повернення до попередніх запитань неможливе.',
    loginRequired: 'Увійдіть на головній сторінці, щоб почати іспит.',
    loadingSession: 'Підготовка іспиту...',
    loadingCategories: 'Завантаження категорій...',
    languageLabel: 'Мова',
    categoryLabel: 'Категорія',
    startExam: 'Почати тест',
    startingExam: 'Завантаження запитань...',
    nextQuestion: 'Наступне запитання',
    finishExam: 'Завершити та перевірити результат',
    questionCounter: 'Запитання',
    globalTime: 'Час усього тесту',
    answeredCount: 'Відповіді',
    remainingCount: 'Залишилось',
    resultTitle: 'Результат іспиту',
    scoreLabel: 'Набрані бали',
    maxScoreLabel: 'Максимальна кількість балів',
    passLabel: 'СКЛАДЕНО',
    failLabel: 'НЕ СКЛАДЕНО',
    passRule: 'Щоб скласти іспит, потрібно набрати щонайменше 68 балів.',
    fetchErrorFallback: 'Не вдалося завантажити набір іспиту.',
    submitErrorFallback: 'Не вдалося перевірити результат іспиту.',
    submitInProgress: 'Перевірка результату...',
    noExamLoaded: 'Виберіть категорію та натисніть старт, щоб завантажити набір іспиту.',
    categoriesErrorFallback: 'Не вдалося завантажити категорії.',
    resultAdTitle: 'Результат після реклами',
    resultAdText: 'Користувачі Free бачать рекламу перед результатом іспиту. Premium прибирає цей крок.',
    resultAdCountdown: 'Результат буде доступний через',
    resultAdContinue: 'Показати результат',
    resultAdPremiumCta: 'Купити Premium',
    summaryTitle: 'Підсумок запитань',
    basicQuestionsTitle: 'Базові запитання',
    specialistQuestionsTitle: 'Спеціалізовані запитання',
    correctAnswer: 'Правильна відповідь',
    wrongAnswer: 'Неправильна відповідь',
    userAnswer: 'Ваша відповідь',
    expectedAnswer: 'Правильна відповідь',
    unanswered: 'Немає відповіді',
    testHistoryTitle: 'Історія тестів',
    noTestHistory: 'Немає збережених тестів.',
  },
  ads: {
    googleSlotTitle: 'Місце для реклами Google',
    wideSkyscraperText: 'Місце для реклами 160 x 600.',
    drivingOfferTitle: 'Пропозиція для водіїв',
    secondSlotText: 'Місце для другої реклами 160 x 600.',
    roadSafetyTitle: 'Пропозиція з безпеки руху',
    drivingSchoolTitle: 'Реклама автошколи',
    examResultTitle: 'Реклама перед результатом',
    mediumRectangleText: 'Місце для реклами 300 x 250.',
  },
  premium: {
    plansError: 'Не вдалося завантажити плани. Спробуйте оновити сторінку.',
    checkoutError: 'Не вдалося почати оплату. Спробуйте ще раз.',
    loading: 'Завантаження...',
    lead: 'Розблокуйте повний доступ до історії іспитів, навчання без реклами та всіх категорій запитань.',
    activeBadge: 'У вас активний Premium',
    activeUntil: 'до',
    loadingPlans: 'Завантаження планів...',
    popular: 'Найпопулярніший',
    featureHistory: 'Повна історія іспитів',
    featureNoAds: 'Навчання без реклами',
    featureAllCategories: 'Усі категорії запитань',
    featureBestDailyPrice: 'Найкраща ціна за день',
    redirecting: 'Перенаправлення...',
    buyNow: 'Купити зараз',
    loginToBuy: 'Увійдіть, щоб купити',
    stripeHintPrefix: 'Оплату обробляє',
    stripeHintSuffix: 'Одноразове списання - без підписки.',
    successTitle: 'Оплату завершено!',
    successText: 'Ваш акаунт активовано. Premium уже активний.',
    successHint: 'Якщо Premium ще не видно в акаунті, оновіть сторінку за мить - активація може тривати кілька секунд.',
    backHome: 'Повернутися на головну',
    cancelTitle: 'Оплату скасовано',
    cancelText: 'З вашої картки нічого не списано.',
    backToPlans: 'Повернутися до планів',
  },
  scopeLabels: { PODSTAWOWY: 'Базовий', SPECJALISTYCZNY: 'Спеціалізований' },
  tagLabels: {
    'znaki-sygnaly': 'Дорожні знаки та сигнали',
    pierwszenstwo: 'Перевага в русі',
    manewry: 'Маневри та зміна напрямку',
    ostroznosc: 'Обережність і уважність',
    'predkosc-odstepy': 'Швидкість і дистанція',
    'piesi-rowerzysci': 'Пішоходи, велосипедисти та переходи',
    'skrzyzowania-pasy': 'Перехрестя та рух смугами',
    'parkowanie-zatrzymanie': 'Паркування та зупинка',
    'warunki-jazdy': 'Умови руху та видимість',
    'stan-kierowcy': 'Стан водія та безпека',
    'pojazd-dokumenty': 'Транспортний засіб, обладнання та документи',
    'transport-ladunek': 'Перевезення пасажирів і вантажів',
    inne: 'Інше',
  },
};
